import { TrelloWindow } from '@trello/window-types';

import { forNamespace } from './forNamespace';
import { AllSubstitutions } from './babble';

declare const window: TrelloWindow;

const formatCounts = forNamespace('counts');

export const localizeCount = (
  name: string,
  count: number,
  substitutions: AllSubstitutions = {},
) => {
  const { counting } = window.__locale;

  return formatCounts([name, counting(count)], {
    count: `${count}`,
    ...substitutions,
  });
};
